// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1770":"06aba0cb","6015":"8edcea0e"}[chunkId] + ".chunk.css";
};